import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('dependentForm', 'documents-complete');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dependent_registration',
  type: 'put',
  slug: [
    'assignments',
    {
      type: 'payload',
      selector: ['id'],
    },
    'documentation_completion',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/dependentForm/documents-completion-req.js